import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {RemoveAccountTeamMemberResultModal} from './remove-account-team-member.result.modal';
import {
    clearResult,
    selectRemoveAccountTeamMemberShown,
    selectRemoveAccountTeamMemberTask,
    selectRemoveAccountTeamMemberUuid,
} from './remove-account-team-member.slice';

export const RemoveAccountTeamMemberResult = () => (
    <BulkActionResult
        actionIdSelector={selectRemoveAccountTeamMemberUuid}
        actionTaskSelector={selectRemoveAccountTeamMemberTask}
        actionShownSelector={selectRemoveAccountTeamMemberShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <RemoveAccountTeamMemberResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
